
<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <h3>{{ $i18n.t(addNewLabel) }}</h3>
        <v-spacer />
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div>
        <v-btn
          class="float-right my-10"
          small
          width="85px"
          color="teal lighten-2"
          :title="$i18n.t('Show List')"
          @click="showList = true"
          v-if="!showList"
        >
          Show List
        </v-btn>
      </div>
      <v-card-text v-if="!showList">
        <consignor-edit
          :singlePage="true"
          @select="select"
          @closeDialog="closeDialog"
          :showClose="true"
          :type="type"
          :consig_id="consignor_id"
        />
      </v-card-text>
      <v-card-text v-else>
        <consignor
          :singlePage="true"
          @select="select"
          @closeDialog="closeDialog"
          :showClose="true"
          :type="type"
          @editConsignor="editConsignor"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import ConsignorEdit from "@/views/consignor/ConsignorEdit.vue";
import Consignor from "@/views/consignor/Consignor.vue";

@Component({
  name: "ConsignorCreate",
  components: {
    ConsignorEdit,
    Consignor,
  },
  props: {
    showDialog: {
      default: false,
    },
    addNewLabel: {
      default: "Create Consignor/Consignee",
    },
    type: {
      default: null,
    },
  },
})
export default class ConsignorCreate extends Vue {
  dialog = false;
  showList = false;
  consignor_id = null;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  async editConsignor(c_id) {
    this.showList = false;
    this.consignor_id = c_id;
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }
}
</script>
